import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

const ShortcodeBlock: React.FC<IWPGBlock> = (props) => <div dangerouslySetInnerHTML={{ __html: props.innerHTML }} />

export default ShortcodeBlock
